import { render, staticRenderFns } from "./DefaultEmailsView.vue?vue&type=template&id=53d2702e&scoped=true"
import script from "./DefaultEmailsView.vue?vue&type=script&lang=js"
export * from "./DefaultEmailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2702e",
  null
  
)

export default component.exports